export default {
    path : "enterprise-recycled",
    name : "enterprise-recycled",
    meta : {
        title : "回收企业"
    },
    component: () => import('@/pages/enterprise/recycled/Index'),
    redirect: {
        name : "enterprise-recycled-whole"
    },
    children: [
        {
            path: 'all',
            name: 'enterprise-recycled-whole',
            meta: {
                title: '回收企业-列表页'
            },
            component: () => import('@/pages/enterprise/list/Index'),
        },
        {
            path: 'search',
            name: 'enterprise-recycled-search',
            meta: {
                title: '回收企业-列表页'
            },
            component: () => import('@/pages/enterprise/list/Index'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/enterprise/recycled_enterprise/index.js